import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import {FusePageSimple, FuseAnimate} from '@fuse';

import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as Actions from 'store/actions';
import { Paper, Grid, Button, Chip, Divider, Typography, Tabs, Tab, AppBar, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@material-ui/core';

import HomeIcon from '@material-ui/icons/Home';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import StarRateIcon from '@material-ui/icons/StarRate';

const styles = theme => ({
    layoutRoot: {},
    pagingPeringkat: {
        textAlign: 'right'
    },
    tabSelected: {
        borderBottom: '5px solid #4EBAE7',
        background: '#ECEFF1',
        color: 'white'
    },
});

class HasilVerval extends Component {
    state = {
        error:0,
        routeParams:{
            foo: 'bar',
            nilai: {},
            tahun: localStorage.getItem('tahun'),
            token: localStorage.getItem('jwt_token'),
            sekolah_id: JSON.parse(localStorage.getItem('user')).sekolah_id,
            nomor: 1
        },
        valueTab: 0,
        tabValue: 0,
        nilai: {},
        nilaiStandar: [],
        catatan_pengawas: '',
        dialogBlocking: true,
        dialogTitle: (<span>Mengecek rapor mutu ...</span>),
        dialogText: (<span>Mohon tunggu beberapa saat ...</span>),
        disableDialogButton: true
    }

    goTolink = (url) => {
        this.props.history.push(url);
    };

    muatData = () => {
        // this.props.setLoading(true);
        let total = 0;
        let nilaiStandar = [];

        // this.props.verval_sekolah.rows.map((option)=>{
        //     nilaiStandar[this.props.verval_sekolah.rows.indexOf(option)] = parseFloat(option['r19']).toFixed(2);

        //     if(isNaN( parseFloat(option['r19']) ) === false ){
        //         total = total+parseFloat(option['r19']);
        //     }else{
        //         total = total+0;
        //     }

        // });

        const array = this.props.verval_sekolah.rows;
        for (let index = 0; index < array.length; index++) {
            const option = array[index];
            
            nilaiStandar[this.props.verval_sekolah.rows.indexOf(option)] = parseFloat(option['r19']).toFixed(2);

            if(isNaN( parseFloat(option['r19']) ) === false ){
                total = total+parseFloat(option['r19']);
            }else{
                total = total+0;
            }
        }

        total = total/8;

        // console.log(total);

        let predikat = null;
        if(total>0 && total<=2.04){
            predikat = 'Menuju SNP 1';
        }else if(total>2.04 && total <=3.70){
            predikat = 'Menuju SNP 2';
        }else if(total>3.70 && total <=5.06){
            predikat = 'Menuju SNP 3';
        }else if(total>5.06 && total <=6.66){
            predikat = 'Menuju SNP 4';
        }else if(total>6.66){
            predikat = 'SNP';
        }

        this.setState({
            ...this.state,
            nilaiSekolah: total.toFixed(2),
            nilaiStandar: nilaiStandar,
            predikat: predikat
        },()=>{
            console.log(this.state);
        });
    }

    handleCloseDialogBlocking = () => {
        this.setState({
            ...this.state,
            dialogBlocking: false,
            hideRapor: false
        })
    }

    handleCloseHitungRaporMutu = () => {
        this.props.history.push("/RaporMutu");
    }

    handleCloseBeranda = () => {
        this.props.history.push("/Beranda");
    }

    componentDidMount = () => {
        this.props.setJudul('Hasil Verval Sekolah');

        this.props.getProsesRapor(this.state.routeParams).then((result)=>{

            // console.log(this.props.proses_rapor_mutu);
            if(this.props.proses_rapor_mutu.total === 0){
                this.setState({
                    ...this.state,
                    dialogTitle: (<span>Apakah Anda sudah melakukan penghitungan rapor mutu?</span>),
                    dialogText: (<span>Sebelum membuka menu ini, silakan Anda melakukan penghitungan rapor mutu sekolah Anda terlebih dahulu. Klik tombol di bawah ini untuk ke menu <b>Hitung Rapor Mutu</b>, atau kembali ke <b>Beranda</b></span>),
                    disableDialogButton: false
                })
            }else{
                this.setState({
                    ...this.state,
                    dialogBlocking: false
                },()=>{

                    this.props.setLoadingBesar(true);
            
                    this.props.getVervalSekolah(this.state.routeParams).then((result)=>{
                        this.muatData();
                        this.props.setLoadingBesar(false);
            
                        let nilai = {};
                        
                        const array = this.props.verval_sekolah.rows;
                        for (let index = 0; index < array.length; index++) {
                            const option = array[index];
                            
                            if(typeof(option.children) !== 'undefined'){
                                const array1 = option.children;
                                for (let index = 0; index < array1.length; index++) {
                                    const optionIndikator = array1[index];
                                    const array2 = optionIndikator.children;
                                    for (let index = 0; index < array2.length; index++) {
                                        const optionSub = array2[index];
                                        nilai[optionSub.sekolah_id+':'+this.state.routeParams.pengguna_id+':'+this.state.routeParams.tahun+':'+optionSub.urut] = Number(optionSub.nilai)   
                                    }
                                }
                            }
                        }
            
                        this.setState({
                            ...this.state,
                            nilai,
                            catatan_pengawas: this.props.verval_sekolah.catatan_verval.catatan
                        },()=>{
                            console.log(this.state);
                        });
                    });

                })
            }
        });

    }

    handleChangeTab = (e,value) => {
        this.props.setLoadingBesar(true);

        this.setState({
            tabValue: value,
            routeParams: {
                ...this.state.routeParams,
                nomor: (value+1)
            }
        },()=>{
            this.props.getVervalSekolah(this.state.routeParams).then((result)=>{
                this.muatData();
                this.props.setLoadingBesar(false);
    
                let nilai = {};

                const array = this.props.verval_sekolah.rows;
                for (let index = 0; index < array.length; index++) {
                    const option = array[index];
                    
                    if(typeof(option.children) !== 'undefined'){
                        const array1 = option.children;
                        for (let index = 0; index < array1.length; index++) {
                            const optionIndikator = array1[index];
                            const array2 = optionIndikator.children;
                            
                            for (let index = 0; index < array2.length; index++) {
                                const optionSub = array2[index];
                                nilai[optionSub.sekolah_id+':'+this.state.routeParams.pengguna_id+':'+this.state.routeParams.tahun+':'+optionSub.urut] = Number(optionSub.nilai)
                            }
                        }
                    }
                }
    
                console.log(nilai);
    
                this.setState({
                    ...this.state,
                    nilai
                },()=>{
                    console.log(this.state);
                });
            });
        });
    }

    render()
    {
        const {classes} = this.props;
        
        return (
            <FusePageSimple
                classes={{
                    root: classes.layoutRoot
                }}
                content={
                    <FuseAnimate
                        animation="transition.slideRightBigIn"
                        duration={400}
                        delay={400}
                    >
                        <div style={{width: '100%', padding: 10}} className="konten-utama">
                            {/* <GhostList/>
                            <GhostList/>
                            <GhostList/>
                            <GhostList/> */}
                            <Dialog
                                open={this.state.dialogBlocking}
                                onClose={this.handleCloseDialogBlocking}
                                aria-labelledby="alert-rapor-mutu-belum"
                                aria-describedby="alert-rapor-mutu-belum"
                            >
                                <DialogTitle id="alert-rapor-mutu-belum-title">{this.state.dialogTitle}</DialogTitle>
                                <DialogContent>
                                <DialogContentText id="alert-rapor-mutu-belum-description">
                                    {this.state.dialogText}
                                </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                <Button onClick={this.handleCloseHitungRaporMutu} color="primary" disabled={this.state.disableDialogButton}>
                                    Hitung Rapor Mutu
                                </Button>
                                <Button onClick={this.handleCloseBeranda} color="primary" autoFocus disabled={this.state.disableDialogButton}>
                                    Beranda
                                </Button>
                                </DialogActions>
                            </Dialog>
                            <div style={{minHeight: 10, width: '100%', background: '#4EBBE8', overflow: 'auto', maxHeight: '42px', display: 'inline-flex'}}>
                                <Chip
                                    icon={<HomeIcon/>}
                                    label=""
                                    className={this.props.classes.chip}
                                    color="primary"
                                    style={{justifyContent: 'start', marginLeft: 0, padding: 5, borderRadius: 0, borderRight: '1px solid #ccc', paddingLeft: '0px', paddingRight: '0px'}}
                                    onClick={()=>{this.goTolink('/Beranda')}}
                                />
                                <Chip
                                    label={"> Hasil Verval"}
                                    className={this.props.classes.chip}
                                    color="secondary"
                                    // onClick={()=>{this.goTolink('/ManajemenPengguna')}}
                                    style={{justifyContent: 'start', marginRight: 0, padding: 5, borderRadius: 0, paddingLeft: 0, paddingRight: 0, fontSize: 12}}
                                />
                            </div>
                            
                            <Paper className="p-8 m-8 mb-8">
                                <Typography variant="title">
                                    Hasil Verifikasi Rapor Mutu
                                </Typography>
                            </Paper>
                            <Paper className="p-8 m-8 mb-8">
                                <Grid container>
                                    <Grid item xs={12}>
                                        <Paper className="p-16 mb-8" style={{color:'#434343',background:'#ffffff'}}>
                                            <Typography variant="title">Catatan dari Pengawas</Typography>
                                            <Divider/>
                                            {!this.state.catatan_pengawas && <Typography style={{color:'#434343', fontStyle: 'italic'}} variant="caption">Belum ada catatan dari pengawas</Typography>}
                                            {this.state.catatan_pengawas && <Typography style={{color:'#434343'}} variant="subheading">{this.state.catatan_pengawas}</Typography>}
                                        </Paper>
                                    </Grid>
                                    <Grid item xs={12}>
                                        {typeof(this.props.location.pathname.split("/")[3]) !== 'undefined' && <Paper className="p-8">
                                            <Button onClick={()=>History.push('/tr/:/progres-verval')}>
                                                <ArrowBackIcon/> &nbsp;Kembali
                                            </Button>
                                        </Paper>}
                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <Paper className="p-8" style={{textAlign:'center', minHeight:'100px'}}>
                                            <Typography variant="subheading" style={{marginBottom:'10px', fontSize: '2vh'}}>
                                                Nilai Rapor Mutu
                                            </Typography>
                                            <Typography variant="display2" style={{fontSize:'6vh'}}>
                                                {this.state.nilaiSekolah}
                                            </Typography>
                                            <Typography variant="caption">
                                                Predikat: {this.state.predikat}
                                            </Typography>
                                            {this.state.predikat === 'Menuju SNP 1' && <div><StarRateIcon/></div>}
                                            {this.state.predikat === 'Menuju SNP 2' && <div><StarRateIcon/><StarRateIcon/></div>}
                                            {this.state.predikat === 'Menuju SNP 3' && <div><StarRateIcon/><StarRateIcon/><StarRateIcon/></div>}
                                            {this.state.predikat === 'Menuju SNP 4' && <div><StarRateIcon/><StarRateIcon/><StarRateIcon/><StarRateIcon/></div>}
                                            {this.state.predikat === 'SNP' && <div><StarRateIcon/><StarRateIcon/><StarRateIcon/><StarRateIcon/><StarRateIcon/></div>}
                                            <br/>
                                            {/* <Divider/>
                                            <br/> */}
                                            {/* <Grid container spacing={8}>
                                                <Grid item xs={6} style={{textAlign:'left'}}>
                                                    Isi: &nbsp;
                                                    <b>
                                                        {!isNaN(this.state.nilaiStandar[0]) && this.state.nilaiStandar[0]}
                                                        {isNaN(this.state.nilaiStandar[0]) && 0}
                                                    </b>
                                                </Grid>
                                                <Grid item xs={6} style={{textAlign:'left'}}>
                                                    Kompetensi Lulusan:&nbsp;
                                                    <b>
                                                        {!isNaN(this.state.nilaiStandar[1]) && this.state.nilaiStandar[1]}
                                                        {isNaN(this.state.nilaiStandar[1]) && 0}
                                                    </b>
                                                </Grid>
                                                <Grid item xs={6} style={{textAlign:'left'}}>
                                                    Pembiayaan:&nbsp;
                                                    <b>
                                                        {!isNaN(this.state.nilaiStandar[2]) && this.state.nilaiStandar[2]}
                                                        {isNaN(this.state.nilaiStandar[2]) && 0}
                                                    </b>
                                                </Grid>
                                                <Grid item xs={6} style={{textAlign:'left'}}>
                                                    PTK:&nbsp;
                                                    <b>
                                                        {!isNaN(this.state.nilaiStandar[3]) && this.state.nilaiStandar[3]}
                                                        {isNaN(this.state.nilaiStandar[3]) && 0}
                                                    </b>
                                                </Grid>
                                                <Grid item xs={6} style={{textAlign:'left'}}>
                                                    Pengelolaan Pendidikan:&nbsp;
                                                    <b>
                                                        {!isNaN(this.state.nilaiStandar[4]) && this.state.nilaiStandar[4]}
                                                        {isNaN(this.state.nilaiStandar[4]) && 0}
                                                    </b>
                                                </Grid>
                                                <Grid item xs={6} style={{textAlign:'left'}}>
                                                    Penilaian Pendidikan:&nbsp;
                                                    <b>
                                                        {!isNaN(this.state.nilaiStandar[5]) && this.state.nilaiStandar[5]}
                                                        {isNaN(this.state.nilaiStandar[5]) && 0}
                                                    </b>
                                                </Grid>
                                                <Grid item xs={6} style={{textAlign:'left'}}>
                                                    Proses:&nbsp;
                                                    <b>
                                                        {!isNaN(this.state.nilaiStandar[6]) && this.state.nilaiStandar[6]}
                                                        {isNaN(this.state.nilaiStandar[6]) && 0}
                                                    </b>
                                                </Grid>
                                                <Grid item xs={6} style={{textAlign:'left'}}>
                                                    Sarpras Pendidikan:&nbsp;
                                                    <b>
                                                        {!isNaN(this.state.nilaiStandar[7]) && this.state.nilaiStandar[7]}
                                                        {isNaN(this.state.nilaiStandar[7]) && 0}
                                                    </b>
                                                </Grid>
                                            </Grid> */}
                                        </Paper>
                                    </Grid>
                                    {/* <Grid item xs={12} sm={6} style={{minHeight:'300px'}}>
                                        <Paper className="p-8" style={{minHeight:'300px', paddingTop:'20px'}}>
                                            <Radar data={this.props.rapor_mutu_radar}/>
                                        </Paper>
                                    </Grid> */}
                                </Grid>
                                <AppBar position="static">
                                    <Tabs 
                                        value={this.state.tabValue} 
                                        onChange={this.handleChangeTab}
                                        // indicatorColor="primary"
                                        // textColor="primary"
                                        variant="scrollable"
                                        scrollButtons="auto"
                                    >
                                        <Tab label="Kompetensi Lulusan" />
                                        <Tab label="Isi" />
                                        <Tab label="Proses" />
                                        <Tab label="Penilaian" />
                                        <Tab label="PTK" />
                                        <Tab label="Sarpras" />
                                        <Tab label="Pengelolaan" />
                                        <Tab label="Pembiayaan" />
                                    </Tabs>
                                </AppBar>
                                <br/>
                                <Divider/>
                                <br/>
                                <Grid container>
                                    <Grid item xs={12} sm={6}>
                                        <Grid container>
                                            <Grid item xs={1} sm={2} className={classes.grids}>
                                                <b>No</b>
                                            </Grid>
                                            <Grid item xs={7} sm={10} className={classes.grids}>
                                                <b>Standar / Indikator / Sub Indikator</b>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} sm={6} className="hilangDiMobile">
                                        <Grid container>
                                            <Grid item xs={3} className={classes.grids} style={{textAlign:'center'}}>
                                                <b>Nilai</b>
                                            </Grid>
                                            {/* <Grid item xs={3} className={classes.grids} style={{textAlign:'center'}}>
                                                <b>Predikat</b>
                                            </Grid> */}
                                            <Grid item xs={4} className={classes.grids} style={{textAlign:'center'}}>
                                                <b>Sumber Data</b>
                                            </Grid>
                                            <Grid item xs={5} className={classes.grids} style={{textAlign:'center'}}>
                                                <b>Verifikasi Pengawas</b>
                                            </Grid>
                                            {/* <Grid item xs={2} className={classes.grids} style={{textAlign: 'right'}}>
                                                &nbsp;
                                            </Grid> */}
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} style={{padding:5}}>
                                        <Divider/>
                                    </Grid>
                                </Grid>
                                {
                                this.props.verval_sekolah.rows
                                .filter(option => typeof(option.children) !== 'undefined')
                                .map((option)=>{
                                    // if(typeof(option.children)!=='undefined'){
                                     
                                        return (
                                            <Grid className="pt-8 pb-8" container style={{background: '#03a9f4',color:'white'}}>
                                                <Grid item xs={12} sm={6}>
                                                    <Grid container className="pl-8">
                                                        <Grid item xs={1} sm={2} className={classes.grids}>
                                                            <b>{option.nomor}</b>
                                                        </Grid>
                                                        <Grid item xs={7} sm={10} className={classes.grids}>
                                                            <b>{option.uraian}</b>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={12} sm={6} className="hilangDiMobile">
                                                    <Grid container>
                                                        <Grid item xs={3} className={classes.grids} style={{textAlign:'center'}}>
                                                            <b>{parseFloat(option.r19).toFixed(2)}</b>
                                                        </Grid>
                                                        <Grid item xs={4} className={classes.grids} style={{textAlign:'center'}}>
                                                            {/* {option.sumber} */}
                                                        </Grid>
                                                        <Grid item xs={5} className={classes.grids} style={{textAlign:'center'}}>
                                                            
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    {option.children.map((optionIndikator)=>{
                                                        return (
                                                            <Grid className="p-8" container style={{background:'#e1f5fe',color:'black'}}>
                                                                <Grid item xs={12} sm={6}>
                                                                    <Grid container>
                                                                        <Grid item xs={1} sm={2} className={classes.grids}>
                                                                            <b>{optionIndikator.nomor}</b>
                                                                        </Grid>
                                                                        <Grid item xs={7} sm={10} className={classes.grids}>
                                                                            <b>{optionIndikator.uraian}</b>
                                                                        </Grid>
                                                                    </Grid>
                                                                </Grid>
                                                                <Grid item xs={12} sm={6} className="hilangDiMobile">
                                                                    <Grid container>
                                                                        <Grid item xs={3} className={classes.grids} style={{textAlign:'center'}}>
                                                                            <b>{parseFloat(optionIndikator.r19).toFixed(2)}</b>
                                                                        </Grid>
                                                                        <Grid item xs={4} className={classes.grids} style={{textAlign:'center'}}>
                                                                            {/* {optionIndikator.sumber} */}
                                                                        </Grid>
                                                                        <Grid item xs={5} className={classes.grids} style={{textAlign:'center'}}>
                                                                            
                                                                        </Grid>
                                                                    </Grid>
                                                                </Grid>
                                                                <Grid item xs={12}>
                                                                    {optionIndikator.children.map((optionSub)=>{
                                                                        return (
                                                                            <Grid className="p-8" container style={{background:(optionSub.sumber === 'Tidak Digunakan' ? '#bbbbbb' : '#f1f8e9'), color:(optionSub.sumber === 'Tidak Digunakan' ? 'gray' : 'black')}}>
                                                                                <Grid item xs={12} sm={6}>
                                                                                    <Grid container>
                                                                                        <Grid item xs={1} sm={2} className={classes.grids}>
                                                                                            <b>{optionSub.nomor}</b>
                                                                                        </Grid>
                                                                                        <Grid item xs={7} sm={10} className={classes.grids}>
                                                                                            <b>{optionSub.uraian}</b>
                                                                                        </Grid>
                                                                                    </Grid>
                                                                                </Grid>
                                                                                <Grid item xs={12} sm={6} className="hilangDiMobile">
                                                                                    <Grid container>
                                                                                        <Grid item xs={3} className={classes.grids} style={{textAlign:'center'}}>
                                                                                            <b>{parseFloat(optionSub.r19).toFixed(2)}</b>
                                                                                        </Grid>
                                                                                        <Grid item xs={4} className={classes.grids} style={{textAlign:'center'}}>
                                                                                            {optionSub.sumber}
                                                                                        </Grid>
                                                                                        <Grid item xs={5} className={classes.grids} style={{textAlign:'center'}}>
                                                                                            {/* <Select
                                                                                                value={this.state.nilai[optionSub.sekolah_id+':'+this.state.routeParams.pengguna_id+':'+this.state.routeParams.tahun+':'+optionSub.urut]}
                                                                                                onChange={this.handleChangeSelect(optionSub.sekolah_id+':'+this.state.routeParams.pengguna_id+':'+this.state.routeParams.tahun+':'+optionSub.urut)}
                                                                                                inputProps={{
                                                                                                    name: 'nilai',
                                                                                                    id: 'nilai',
                                                                                                }}
                                                                                                style={{minWidth:'170px'}}
                                                                                            >
                                                                                                <MenuItem value={9}>Belum Diverifikasi</MenuItem>
                                                                                                <MenuItem value={1}><b style={{color:'green'}}>Setuju</b></MenuItem>
                                                                                                <MenuItem value={0}><b style={{color:'red'}}>Koreksi</b></MenuItem>
                                                                                            </Select> */}
                                                                                            {Number(optionSub.nilai) === 9 && <Typography style={{color:'gray', fontWeight:'bold'}}>Belum Diverifikasi</Typography>}
                                                                                            {Number(optionSub.nilai) === 1 && <Typography style={{color:'green', fontWeight:'bold'}}>Setuju</Typography>}
                                                                                            {Number(optionSub.nilai) === 2 && <Typography style={{color:'red', fontWeight:'bold'}}>Koreksi</Typography>}
                                                                                        </Grid>
                                                                                    </Grid>
                                                                                    <Grid item xs={12} style={{padding:5}}>
                                                                                        <Divider/>
                                                                                    </Grid>
                                                                                </Grid>
                                                                            </Grid>
                                                                        )
                                                                    })}
                                                                </Grid>
                                                            </Grid>
                                                        )
                                                    })}
                                                </Grid>
                                                <Grid item xs={12} style={{padding:5}}>
                                                    <Divider/>
                                                </Grid>
                                            </Grid>
                                        )
                                       
                                    // } 
                                })}
                            </Paper>
                        </div>
                    </FuseAnimate>
                }
            />
        )
    }

}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getSekolah: Actions.getSekolah,
        setKunciKonfirmasiInstrumen: Actions.setKunciKonfirmasiInstrumen,
        getKonfirmasiSelesai: Actions.getKonfirmasiSelesai,
        getKemajuanTotal: Actions.getKemajuanTotal,
        getPeringkatPengisian: Actions.getPeringkatPengisian,
        setLoading: Actions.setLoading,
        setJudul: Actions.setJudul,
        getProsesRapor: Actions.getProsesRapor,
        getRaporMutuRadar: Actions.getRaporMutuRadar,
        setDataTahun: Actions.setDataTahun,
        setDataWilayah: Actions.setDataWilayah,
        getVervalSekolah: Actions.getVervalSekolah,
        setLoadingBesar: Actions.setLoadingBesar
    }, dispatch);
}

function mapStateToProps({ Sekolah, Instrumen, RaporMutu }) {

    return {
        sekolah: Sekolah.sekolah,
        konfirmasi_instrumen_id: Instrumen.konfirmasi_instrumen_id,
        konfirmasi_instrumen: Instrumen.konfirmasi_instrumen,
        kemajuan_total: Instrumen.kemajuan_total,
        peringkat_pengisian: Instrumen.peringkat_pengisian,
        proses_rapor_mutu: RaporMutu.proses_rapor_mutu,
        rapor_mutu_radar: RaporMutu.rapor_mutu_radar,
        data_tahun: RaporMutu.data_tahun,
        data_wilayah: RaporMutu.data_wilayah,
        verval_sekolah: RaporMutu.verval_sekolah
    }
}

// export default withStyles(styles, {withTheme: true})(Beranda);
export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(HasilVerval)));



// WEBPACK FOOTER //
// ./src/main/content/Notifikasi/HasilVerval.js